import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Avatar,
  Box,
  Container,
  Link,
  Typography,
} from "@material-ui/core";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
}));

// Shown instead of any team-scoped page (see PrivateRoute in App.js) to a
// signed-in user who isn't on a team - someone who left, was removed by a
// leader, or whose last team went away. Everything else in the app is scoped
// to the active team, so without this those pages just sit on a spinner.
// Joining again needs no UI here: opening an invitation link while signed in
// offers to join (Signup's handleJoin), and the leader has to send that link
// either way.
export const NoTeam = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="xs">
      <div className={classes.content}>
        <Avatar className={classes.avatar}>
          <GroupAddIcon />
        </Avatar>
        <Typography component="h1" variant="h5" gutterBottom>
          You are not on a team yet.
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Contact a team leader to send you another invitation.
        </Typography>
        <Box mt={3}>
          <Typography variant="body2" color="textSecondary">
            <Link component={RouterLink} to="/account">
              Account settings
            </Link>
          </Typography>
        </Box>
      </div>
    </Container>
  );
};

export default NoTeam;
